import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enAbout from './locales/en/about-translations.json';
import enCareers from './locales/en/careers-translations.json';
import enCommon from './locales/en/common-translations.json';
import enHome from './locales/en/home-translations.json';
import enPrivacy from './locales/en/privacy-translations.json';
import enSupport from './locales/en/support-translations.json';
import esAbout from './locales/es/about-translations.json';
import esCareers from './locales/es/careers-translations.json';
import esCommon from './locales/es/common-translations.json';
import esHome from './locales/es/home-translations.json';
import esPrivacy from './locales/es/privacy-translations.json';
import esSupport from './locales/es/support-translations.json';

const STORAGE_KEY = 'liza_public_web_lang';

function readStoredLanguage(): 'en' | 'es' {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'es' || v === 'en') {
      return v;
    }
  } catch {
    /* ignore */
  }
  if (typeof navigator !== 'undefined') {
    const nav = navigator.language.toLowerCase();
    if (nav.startsWith('es')) {
      return 'es';
    }
  }
  return 'en';
}

function setDocumentLang(lng: string): void {
  document.documentElement.lang = lng.startsWith('es') ? 'es' : 'en';
}

const resources = {
  en: {
    about: enAbout,
    careers: enCareers,
    common: enCommon,
    home: enHome,
    privacy: enPrivacy,
    support: enSupport,
  },
  es: {
    about: esAbout,
    careers: esCareers,
    common: esCommon,
    home: esHome,
    privacy: esPrivacy,
    support: esSupport,
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: readStoredLanguage(),
  fallbackLng: 'en',
  supportedLngs: ['en', 'es'],
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
  // Bundled JSON resources load synchronously at init; suspense would add boundary churn without benefit.
  react: { useSuspense: false },
});

setDocumentLang(i18n.language);

i18n.on('languageChanged', (lng) => {
  setDocumentLang(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng.startsWith('es') ? 'es' : 'en');
  } catch {
    /* ignore */
  }
});

// oxlint-disable-next-line import/no-default-export
export default i18n;
